import CampaignStatistics from "../CampaignStatistics";
import CampaignTranslations from "../CampaignTranslations";
import Trigger from "../Trigger";
import Distribution from "./distribution";
import Questions from "./questions";
import { ECampaignSurveyType } from "./questions/LeftSidebar/constants";
import Templates from "./questions/RightSidebar/components/Templates";

export enum ECampaignTabs {
  QUESTIONS = 0,
  TEMPLATES,
  DISTRIBUTION,
  TRIGGERS,
  TRANSLATION,
  STATISTICS,
}

export const campaignDetailsTabList = [
  {
    index: ECampaignTabs.QUESTIONS,
    label: "questions",
    children: <Questions />,
  },
  {
    index: ECampaignTabs.TEMPLATES,
    label: "template",
    children: <Templates />,
  },
  {
    index: ECampaignTabs.DISTRIBUTION,
    label: "share",
    children: <Distribution />,
  },
  {
    index: ECampaignTabs.TRIGGERS,
    label: "trigger",
    children: <Trigger />,
  },
  {
    index: ECampaignTabs.TRANSLATION,
    label: "translation",
    children: <CampaignTranslations />,
  },
  {
    index: ECampaignTabs.STATISTICS,
    label: "statistics",
    children: <CampaignStatistics />,
  },
];

export const unsavedDialogWarning = {
  title: "Unsaved changes",
  description: "Do you want to leave ? Changes you made may not be saved.",
};

export const questionTypePlaceholders = {
  hy: {
    [ECampaignSurveyType.Welcome]:
      "Բարի գալուստ",
    [ECampaignSurveyType.Nps]:
      "0-10 բալային սանդղակով, որքանո՞վ է հավանական, որ Դուք կառաջարկեք [ընկերությունը/ապրանքը/ծառայությունը] ձեր ընկերոջը կամ գործընկերոջը:",
    [ECampaignSurveyType.ServiceQualityScore]:
      "0-10 բալային սանդղակով, որքանո՞վ է հավանական, որ Դուք կառաջարկեք [ընկերությունը] որպես աշխատանքի վայր:",
    [ECampaignSurveyType.CustomerSatisfactionScore]:
      "Որքա՞նով եք գոհ Ձեր վերջին փորձից [արտադրանքի/ծառայության/փոխազդեցության] հետ։",
    [ECampaignSurveyType.CustomerEffortScore]:
      "Որքա՞նով էր հեշտ այսօր լուծել Ձեր խնդիրը։",
    [ECampaignSurveyType.Final]:
      "Շնորհակալություն",
  },
  en: {
    [ECampaignSurveyType.Welcome]:
      "Welcome",
    [ECampaignSurveyType.Nps]:
      "On a scale of 0-10, how likely are you to recommend [company/product/service] to a friend or colleague?",
    [ECampaignSurveyType.ServiceQualityScore]:
      "On a scale of 0-10, how likely are you to recommend [company] as a place to work?",
    [ECampaignSurveyType.CustomerSatisfactionScore]:
      "How satisfied are you with your recent experience with [product/service/interaction]?",
    [ECampaignSurveyType.CustomerEffortScore]:
      "How easy was it to resolve your issue with us today?",
    [ECampaignSurveyType.Final]:
      "Thank you",
  },
  ru: {
    [ECampaignSurveyType.Welcome]:
      "Добро пожаловать",
    [ECampaignSurveyType.Nps]:
      "По шкале от 0 до 10, насколько вероятно, что Вы порекомендуете [компанию/продукт/услугу] другу или коллеге?",
    [ECampaignSurveyType.ServiceQualityScore]:
      "По шкале от 0 до 10, насколько вероятно, что Вы порекомендуете [компанию] как место работы?",
    [ECampaignSurveyType.CustomerSatisfactionScore]:
      "Насколько Вы удовлетворены своим недавним опытом взаимодействия с [продуктом/услугой/сервисом]?",
    [ECampaignSurveyType.CustomerEffortScore]:
      "Насколько легко было решить Вашу проблему сегодня?",
    [ECampaignSurveyType.Final]:
      "Спасибо",
  },
};

export const questionTypeAnswerScales = {
  hy: {
    [ECampaignSurveyType.Nps]: {
      likely: "Հավանական չէ",
      unlikely: "Հավանական է",
    },
    [ECampaignSurveyType.ServiceQualityScore]: {
      likely: "Հավանական չէ",
      unlikely: "Հավանական է",
    },
    [ECampaignSurveyType.CustomerSatisfactionScore]: {
      likely: "Գոհ չեմ",
      unlikely: "Գոհ եմ",
    },
    [ECampaignSurveyType.CustomerEffortScore]: {
      likely: "Դժվար էր",
      unlikely: "Հեշտ էր",
    }
  },
  en: {
    [ECampaignSurveyType.Nps]: {
      likely: "Not Likely",
      unlikely: "Likely",
    },
    [ECampaignSurveyType.ServiceQualityScore]: {
      likely: "Not Likely",
      unlikely: "Likely",
    },
    [ECampaignSurveyType.CustomerSatisfactionScore]: {
      likely: "Not satisfied",
      unlikely: "Satisfied",
    },
    [ECampaignSurveyType.CustomerEffortScore]: {
      likely: "Not easy",
      unlikely: "Easy",
    }
  },
  ru: {
    [ECampaignSurveyType.Nps]: {
      likely: "Маловероятно",
      unlikely: "Вероятно",
    },
    [ECampaignSurveyType.ServiceQualityScore]: {
      likely: "Маловероятно",
      unlikely: "Вероятно",
    },
    [ECampaignSurveyType.CustomerSatisfactionScore]: {
      likely: "Не удовлетворён",
      unlikely: "Удовлетворён",
    },
    [ECampaignSurveyType.CustomerEffortScore]: {
      likely: "Было трудно",
      unlikely: "Было легко",
    }
  },
};
